import { render, staticRenderFns } from "./activity-add.vue?vue&type=template&id=1a667fc0&scoped=true&"
import script from "./activity-add.vue?vue&type=script&lang=js&"
export * from "./activity-add.vue?vue&type=script&lang=js&"
import style0 from "./activity-add.vue?vue&type=style&index=0&id=1a667fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a667fc0",
  null
  
)

export default component.exports